import axios from "axios";

export const POST_CARGAR_SECTOR = 'POST_CARGAR_SECTOR';

export const postCargarSector = (values) => (dispatch) => {
  return dispatch({
    type: POST_CARGAR_SECTOR,
    payload: axios
      .post("dependenciaEmpleador/cargarSector", values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};